import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  listTeachers,
  getTeacherDetail,
  assignStudent,
  removeStudentFromTeacher,
  searchStudents,
  searchTeachers,
} from '@/api/admin';

export function useTeachers(page = 1, perPage = 20) {
  return useQuery({
    queryKey: ['admin', 'teachers', page, perPage],
    queryFn: () => listTeachers(page, perPage),
  });
}

export function useTeacherDetail(id: string) {
  return useQuery({
    queryKey: ['admin', 'teachers', id],
    queryFn: () => getTeacherDetail(id),
    enabled: !!id,
  });
}

export function useSearchStudents(search: string) {
  return useQuery({
    queryKey: ['admin', 'students', 'search', search],
    queryFn: () => searchStudents(search),
    enabled: search.length >= 2,
    placeholderData: (prev) => prev,
  });
}

export function useSearchTeachers(search: string) {
  return useQuery({
    queryKey: ['admin', 'teachers', 'search', search],
    queryFn: () => searchTeachers(search),
    enabled: search.length >= 2,
    placeholderData: (prev) => prev,
  });
}

export function useAssignStudent() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ teacherID, studentID }: { teacherID: string; studentID: string }) =>
      assignStudent(teacherID, { student_id: studentID }),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'teachers'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'students', vars.studentID] });
    },
  });
}

export function useRemoveStudentFromTeacher() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ teacherID, studentID }: { teacherID: string; studentID: string }) =>
      removeStudentFromTeacher(teacherID, studentID),
    onSuccess: (_data, vars) => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'teachers'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'students', vars.studentID] });
    },
  });
}
